<template>
  <div>
    <EditorNav />
    
    <Stepper step="3" />
    <div v-if="showFreeBanner">
      <h6 class="center">The free plan allows for tutorials up to 5 minutes in length. Please <a href="/settings#plan">upgrade to the Maker or Team plan</a> to publish longer tutorials.<br><br></h6>
    </div>
    <div v-if="showMakerBanner">
      <h6 class="center">The Maker plan allows for tutorials up to 10 minutes in length. Please <a href="/settings#plan">upgrade to the Team plan</a> to publish longer tutorials.<br><br></h6>
    </div>
    <div class="container loader" v-if="loading" style="margin-top: 84px;">
      <div class="progress">
        <div class="indeterminate"></div>
      </div>
    </div>
    <div class="container preview-bar" v-if="!loading">
      <div class="tutorial-info">
        <div class="preview-title">{{title}}</div>
        <div class="preview-description">{{description}}</div>
      </div>
      <div class="preview-actions">
        <a class="btn btn-flat" :href="'/tutorials/describe/' +  this.$route.params.id">EDIT</a>
        <a class="btn btn-flat" @click="publishDraft()" :class="{disabled: processing || !allowPublish }">PUBLISH</a>
      </div>
    </div>
    <Viewer :setProcessing="setProcessing" :processing="processing" v-if="!loading" />
  </div>
</template>

<script>
import featureGate from '@/mixins/featureGate';
import EditorNav from "@/components/EditorNav";
import Stepper from "@/components/Stepper";
import Viewer from "@/containers/Viewer";
import Sidebar from "@/components/Sidebar";
import cognitoAuth from "@/plugins/cognito";
import GqlQuery from "@/plugins/gql";


export default {
  mixins: [featureGate],
  mounted() {
    cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (loggedIn) {
        cognitoAuth.getUserAttributes(function(err, user_attributes) {
          self.user_org = user_attributes['custom:organization_id'];
          self.user_email = user_attributes['email'];
          self.loadTutorial();
          GqlQuery.getArticles(function (err, response) {
            if (err) {
              self.error = err;
            }
            response.then(function (val) {
              self.articles = val.data.articles;
              self.checkPlanForTutorials(self.articles).then(function (resulter) {
                console.log("resulter", resulter)
                self.allowPublish=resulter;
              });
              //console.log(self.articles)
              let publishedTutorials=0;
              self.articles.forEach(article => {
                //console.log("total chapters: ", article.chapters.length)
                article.chapters.forEach(tutorial => {
                    if(tutorial.published){
                      if(tutorial.id != self.$route.params.id){
                        publishedTutorials++;
                      }
                    }
                });
              });
              self.publishedTutorials=publishedTutorials;
            });
          });
        });
      }
    });
    var self = this;
  },
  updated() {},
  name: "Preview",
  data() {
    return {
      processing: false,
      loading: true,
      title: "Loading",
      description: "-",
      user_org: false,
      user_email: false,
    };
  },
  methods: {
    setProcessing(value) {
      this.processing = value;
    },

    loadTutorial(cb) {
      let self = this
      GqlQuery.getTutorial(this.$route.params.id, "en", function(
        err,
        response
      ) {
        if (err) {
          self.error = err;
        }
        response.json().then(function(val) {
          let tutorial = val.data.chapter;
          let draft = JSON.parse(tutorial.draft);
          let authed = (self.user_org && tutorial.organization && tutorial.organization.id == self.user_org);
          if (!authed && self.user_email != 'alex@fyi.io') {
            M.toast({
              html:
                "You are not authorized to edit this tutorial",
              inDuration: 3000
            });
            window.location = "/tutorials"
            return
          }
          self.title = draft.title;
          self.description = draft.description;
          self.loading = false;
        });
      });
    },

    publishDraft(cb) {
      let self=this;
      console.log("publishing draft")
      GqlQuery.getTutorial(this.$route.params.id, "en", function(
        err,
        response
      ) {
        if (err) {
          self.error = err;
        }
        response.json().then(function(val) {
          let variables = val.data.chapter;

          GqlQuery.publishDraft(variables, (err, result) => {
            if (err) {
              this.error = err;
              M.toast({
                html:
                  "There was an error updating your tutorial, please try again or contact Fyiio support",
                inDuration: 3000
              });
            } else {
              if (cb && typeof cb == "function") {
                cb();
              }
              M.toast({
                html: "Tutorial successfully published!",
                inDuration: 3000
              });
              window.location = "/tutorials/";
            }
          });
        });
      });
      
    }
  },
  components: {
    Viewer,
    EditorNav,
    Stepper
  }
};
</script>
<style scoped>
#toast-container {
  min-width: 10%;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  margin-top: -69px;
}
</style>
<style scoped>
.preview-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.preview-actions {
  text-align: right;
  flex-shrink: 0;
}
h2 {
  color: #58595b;
  font-family: Roboto;
  font-size: 24px;
  line-height: 32px;
  margin-top: 60px;
  margin-bottom: 24px;
}
button {
  margin-left: 10px;
}
.time-to-complete label {
  left: 0;
}
.right.helper-text {
  text-align: right;
}
.btn-flat {
  color: #27aae1;
}
.btn {
  font-weight: 500;
}
.btn-flat:hover {
  color: white;
  background-color: #27aae1;
}
.progress {
  background-color: #7ac7e7;
}
.progress .determinate,
.progress .indeterminate {
  background-color: #29abe1;
}
.preview-title {
  color: rgba(0,0,0,0.87);	font-family: Roboto;	font-size: 16px;	line-height: 24px;
}
.preview-description {
  color: rgba(0,0,0,0.54);	font-family: Roboto;	font-size: 14px;	line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/containers/dashboard/template/Preview.vue